"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineResponse20012 = void 0;
const ioffice365_user_entity_1 = require("./ioffice365-user-entity");
function parseInlineResponse20012(data) {
    if (data.value !== null && typeof data.value === 'object')
        data.value = data.value.map((x) => (0, ioffice365_user_entity_1.parseIOffice365UserEntity)(x));
    return data;
}
exports.parseInlineResponse20012 = parseInlineResponse20012;
